// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3Cto0","unreadBadge":"styles_unreadBadge__1gC4w","modalContent":"styles_modalContent__13khI","modal":"styles_modal__5P2Un"};